package br.com.duoma.duomaproducao.ui.misc

import androidx.compose.runtime.Composable
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.unit.dp

@Composable
fun isCompactScreen(): Boolean {
    val density = LocalDensity.current
    val windowInfo = LocalWindowInfo.current
    return with(density) { windowInfo.containerSize.width.toDp() } < 600.dp
}
@Composable
fun <T> mediaQuery( onDesktop : T, onCompact : T,) : T {
    if (isCompactScreen())
        return onCompact
    return onDesktop
}
